import { createAsyncThunk } from '@reduxjs/toolkit';

import FAQ_API from './faq.api';

// Categories
export const getFaqCategoriesAction = createAsyncThunk<any, undefined>(
  'list_faq_categories',
  async (_, { rejectWithValue }) => {
    try {
      const data = await FAQ_API.getCategoriesAPI();
      return data;
    } catch (err: any) {
      return rejectWithValue(err);
    }
  },
);

export const postFaqCategoryAction = createAsyncThunk<any, Faq.ParamsPostCategory>(
  'post_faq_category',
  async (data, { rejectWithValue }) => {
    try {
      const result = await FAQ_API.postCategoryAPI(data);
      return result;
    } catch (err: any) {
      return rejectWithValue(err?.message || err?.name);
    }
  },
);

export const putFaqCategoryAction = createAsyncThunk<any, Faq.ParamsPutCategory>(
  'put_faq_category',
  async (data, { rejectWithValue }) => {
    try {
      const result = await FAQ_API.updateCategoryAPI(data);
      return result;
    } catch (err: any) {
      return rejectWithValue(err?.message || err?.name);
    }
  },
);

export const deleteFaqCategoryAction = createAsyncThunk<any, number>(
  'delete_faq_category',
  async (id, { rejectWithValue }) => {
    try {
      const result = await FAQ_API.deleteCategoryAPI(id);
      return result;
    } catch (err: any) {
      return rejectWithValue(err?.message || err?.name);
    }
  },
);

// Items
export const getFaqItemsAction = createAsyncThunk<any, Faq.ParamsGetItems>(
  'list_faq_items',
  async (params, { rejectWithValue }) => {
    try {
      const data = await FAQ_API.getItemsAPI(params);
      return data;
    } catch (err: any) {
      return rejectWithValue(err);
    }
  },
);

export const postFaqItemAction = createAsyncThunk<any, Faq.ParamsPostItem>(
  'post_faq_item',
  async (data, { rejectWithValue }) => {
    try {
      const result = await FAQ_API.postItemAPI(data);
      return result;
    } catch (err: any) {
      return rejectWithValue(err?.message || err?.name);
    }
  },
);

export const putFaqItemAction = createAsyncThunk<any, Faq.ParamsPutItem>(
  'put_faq_item',
  async (data, { rejectWithValue }) => {
    try {
      const result = await FAQ_API.updateItemAPI(data);
      return result;
    } catch (err: any) {
      return rejectWithValue(err?.message || err?.name);
    }
  },
);

export const deleteFaqItemAction = createAsyncThunk<any, number>(
  'delete_faq_item',
  async (id, { rejectWithValue }) => {
    try {
      const result = await FAQ_API.deleteItemAPI(id);
      return result;
    } catch (err: any) {
      return rejectWithValue(err?.message || err?.name);
    }
  },
);
